import { render, staticRenderFns } from "./LoginPersonalizeListItem.vue?vue&type=template&id=553fc93a&scoped=true"
import script from "./LoginPersonalizeListItem.vue?vue&type=script&lang=js"
export * from "./LoginPersonalizeListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553fc93a",
  null
  
)

export default component.exports